// extracted by mini-css-extract-plugin
module.exports = {"container":"e_b4","image":"e_c4","imageImage":"e_d4","description":"e_e4","title":"e_f4","button":"e_g4"};